import React from 'react';

export default function Warning() {
  return (
    <>
      <h1>WARNING! if you re-submit, you'll overwrite your last predications!</h1>
      <button>Edit</button>
    </>
  );
}
